import type { QRCodeToDataURLOptions } from 'qrcode';

export const QR_PNG_SIZE = 1024;
export const QR_QUIET_ZONE = 96;

export function planSlug(name: string): string {
  const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  return slug || 'canada-esim';
}

export function qrPngOptions(): QRCodeToDataURLOptions {
  return {
    errorCorrectionLevel: 'M',
    margin: 4,
    width: QR_PNG_SIZE,
    color: { dark: '#000000', light: '#ffffff' },
  };
}

/** White margin in a square PNG when `margin` modules surround `modules` of data. */
export function quietZonePx(modules: number, marginModules: number, size = QR_PNG_SIZE): number {
  const total = modules + marginModules * 2;
  if (total <= 0) return 0;
  return Math.floor((size * marginModules) / total);
}
